import { ReloadOutlined, WarningOutlined } from "@ant-design/icons"
import { Button, Tooltip } from "antd"
import { CSSProperties } from "react"

import Flex from "#blocks/Flex"

interface ErrorFallbackCardProps {
  error?: Error
  context?: string
  style?: CSSProperties
  onRetry?: () => void
}

/**
 * Card/box error fallback for tiles, cards, sections.
 * Centered layout with icon, message, and optional retry button.
 */
const ErrorFallbackCard = ({
  error,
  context,
  style,
  onRetry,
}: ErrorFallbackCardProps) => {
  const isDev = import.meta.env.DEV

  return (
    <Flex
      col
      center
      style={{
        padding: 12,
        backgroundColor: "rgba(255,77,79,0.06)",
        border: "1px dashed rgba(255,77,79,0.4)",
        borderRadius: 8,
        minHeight: 60,
        gap: 6,
        ...style,
      }}
    >
      <WarningOutlined style={{ color: "#ff4d4f", fontSize: 18 }} />
      <span
        style={{
          fontSize: 11,
          color: "#666",
          textAlign: "center",
          lineHeight: 1.3,
        }}
      >
        {context ?? "Something went wrong"}
      </span>

      {isDev && error?.message && (
        <Tooltip title={error.message}>
          <span
            style={{
              fontSize: 10,
              color: "#999",
              maxWidth: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {error.message.slice(0, 50)}
            {error.message.length > 50 ? "..." : ""}
          </span>
        </Tooltip>
      )}

      {onRetry && (
        <Button
          size="small"
          icon={<ReloadOutlined />}
          onClick={onRetry}
          style={{ marginTop: 4 }}
        >
          Retry
        </Button>
      )}
    </Flex>
  )
}

export default ErrorFallbackCard
